import React, { useMemo } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@material-ui/core';

const PendingSampleTable = ({ samples = [], searchTerm = '', onStartSampling, classes }) => {
  const filteredSamples = useMemo(() => {
    return [...samples]
      .sort((a, b) => Number(b.wH_DocketNumber) - Number(a.wH_DocketNumber))
      .filter(row => {
        const search = searchTerm.toLowerCase();

        return (
          row.wH_DocketNumber?.toString().includes(search) ||
          row.customer?.toLowerCase().includes(search) ||
          row.sP_Number?.toLowerCase().includes(search) ||
          row.sampleHandler?.toLowerCase().includes(search)
        );
      });
  }, [samples, searchTerm]);

  return (
    <TableContainer component={Paper} className={classes.tableContainer} style={{ flex: 1 }}>
      <Table stickyHeader size="small">
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeadCell}>WH Docket #</TableCell>

            <TableCell className={classes.tableHeadCell}>Customer</TableCell>

            <TableCell className={classes.tableHeadCell}>SP Number</TableCell>

            <TableCell className={classes.tableHeadCell}>Handler</TableCell>

            <TableCell className={classes.tableHeadCell} align="center">
              Action
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {filteredSamples.map(row => (
            <TableRow key={row.id} hover>
              <TableCell className={classes.tableCell}>
                <Button
                  className={classes.docketBtn}
                  onClick={() =>
                    window.open(`https://logwatch.myreports.online/dockets?docket=${row.wH_DocketNumber}`, '_blank')
                  }>
                  {row.wH_DocketNumber}
                </Button>
              </TableCell>

              <TableCell className={classes.tableCell}>{row.customer ?? '—'}</TableCell>

              <TableCell className={classes.tableCell}>{row.sP_Number ?? '—'}</TableCell>

              <TableCell className={classes.tableCell}>{row.sampleHandler ?? '—'}</TableCell>

              <TableCell className={classes.tableCell} align="center">
                <Button
                  size="small"
                  variant="outlined"
                  color="primary"
                  style={{ fontWeight: 600 }}
                  onClick={() => onStartSampling(row)}>
                  Start Sampling
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PendingSampleTable;
